import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row,} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { NEVER_ATTENDED_REPORT } from "../../helpers/url_helper";
import CommanDataTable from "../../Components/Common/DataTable";
import moment from "moment";
import { formatDate } from "../../Components/Common/FormDateTime";
import { APIClient } from "../../helpers/api_helper";
import { getPreviousDate, setCurrentDate } from "../../Components/Common/DefaultDateSet";
import { HandleErrorMessage } from "../../Components/Common/HandleErrorMessage";
import ModalNeverAttended from "../../Components/Common/ModalNeverAttended";
import { useProfileData } from "../../Components/Hooks/UserHooks";
import { useNavigate } from "react-router-dom";
import SubExpired from "../../Components/Common/subExpired";
import { CommanDataTables } from "../../Components/Common/DashboardDataTbale";
import CalculateRemainingDays from "../../Components/Common/CalculateRemainingDays";

const api = new APIClient();

const ConsolidateNeverAttended = ({appliedFilters ,selectedFromDate,selectedEmployeeOptions,selectedToDate ,teamIndu }) => {
  document.title = "Never Attended";
  // permission type
  const permissionType = JSON.parse(localStorage.getItem("permission"));
  const loginType = JSON.parse(localStorage.getItem("logintype"));
  const BooleanWithSingleEmployeeLogin = ((loginType === "employee") && (permissionType.length === 0))

  const navigate = useNavigate();
  // profile data get in
  const { profileData } = useProfileData();
  // date pass in
  const previewsDate = getPreviousDate();
  const currentDate = setCurrentDate();

  // date picker state
  const [selectedFromDate_Test_, setSelectedFromDate_Test] = useState(previewsDate);
  const [selectedToDate_Test, setSelectedToDate_Test] = useState(currentDate);
  const [selectedFromDateTwo, setSelectedFromDateTwo] = useState(selectedFromDate_Test_);
  const [selectedToDateTwo, setSelectedToDateTwo] = useState(selectedToDate_Test);
  const [debouncedSearchText, setDebouncedSearchText] = useState('');
  const [filterData, setFilteredData] = useState([]);
  // leader state
  const [isLoading, setIsLoading] = useState(false);
  const [isExpiredModalOpen, setIsExpiredModalOpen] = useState(true);
  // employee select
  const [selectedEmployeeOptions2, setSelectedEmployeeOptions2] = useState([]);
  const [prevEmployeesIds_Test, setPrevEmployeesIds_Test] = useState([]);
  // Pagination settings
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // table data state
  const [neverAttendData, setNeverAttendData] = useState([]);

  const [handleSubmits, setHandleSubmit] = useState(false);



  const [modal_animationFlip, setmodal_animationFlip] = useState(false);
  const [outgoingCall, setOutgoingCall] = useState([]);

  //search field state
  const [query, setQuery] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState('');
  const [isFirstEffectRun, setIsFirstEffectRun] = useState(false);
  const [error, setError] = useState("");
  const remainingDays = CalculateRemainingDays();


  const column = [
    {
      name: <span className="font-weight-bold fs-13"> SN.</span>,
      width: "6%",
      selector: (row, index) => index + 1,
      sortable: true, // This sets the width of the "Sr. No" column to 30px
    },

    {
      name: (
        <span
          className="font-weight-bold fs-13 text-center fs-2"
          style={{ textTransform: "capitalize" }}
        >
          Employee
        </span>
      ),
      selector: (row) => row?.fullName,
      cell: (row) => (
        <div className="mt-2 mb-2">
          <h5
            className="font-weight-bold fs-13"
            style={{ textTransform: "capitalize" }}
          >
            {row?.fullName}
          </h5>
          <h6 className="text-center- font-weight-bold fs-13">
            {row?.countryCode + `-` + row?.mobileNumber}
          </h6>
        </div>
      ),
      sortable: true,
    },


    {
      name: <span className="font-weight-bold fs-13"> Team Name</span>,
      selector: (row) => row.team,
    },
    {
      name: (
        <span
          className="font-weight-bold fs-13 text-center fs-2 fs-2"
          style={{ textTransform: "capitalize" }}
        >
          Client Name
        </span>
      ),
      selector: (row) => row?.name,
      cell: (row) => (
        <div className="mt-2 mb-2">
          <h5
            className="font-weight-bold fs-13"
            style={{ textTransform: "capitalize" }}
          >
            {row?.name}
          </h5>
          <h6 className="text-center- font-weight-bold fs-13">
            {row?.phoneNumber}
          </h6>
        </div>
      ),
      sortable: true,
    },

    {
      name: <span className="font-weight-bold fs-13 fs-2">Date</span>,
      selector: (row) => row?.date,
      cell: (row) => (
        <div className="timeSet">
          {row?.date?.map((callDate, index) => (
            <React.Fragment key={index}>
              <span>{moment(callDate.date).format("DD MMM YYYY")}</span>
              <br />
              {index !== row.date.length - 1 && <br />}
            </React.Fragment>
          ))}
        </div>
      ),
      sortable: true,
    },


    {
      name: <span className="font-weight-bold fs-13 fs-2">Time</span>,
      selector: (row) => (
        <div className="timeSet">
          {row?.time?.map((callTime, index) => {
            const momentObj = moment(callTime.date).format("hh:mm A");
            return (
              <React.Fragment key={index}>
                <span className="gap-2">{momentObj}</span>
                <br />
                {index !== row.time.length - 1 && <br />}
              </React.Fragment>
            );
          })}
        </div>
      ),
      // sortable: true
    },

    {
      name: <span className="font-weight-bold fs-13 fs-2">Call Type</span>,
      selector: (row) => (
        <div className="timeSet">
          {row?.dataAndType?.every(
            (callType) =>
              callType?.type !== "MISSED" && callType?.type !== "REJECTED"
          ) ? (
            <span style={{ textAlign: "center" }}>-</span>
          ) : (
            row.type.map((callType, index) => {
              let content;
              switch (callType.type) {
                case "OUTGOING":
                  content = (
                    <>
                      <div className="sn-call-type-newer-call">
                      <i className="mdi mdi-phone-outgoing sn-out-going-text" />
                      <span className="badge badge-soft-info sn-out-going-call">
                          {callType.type}
                        </span>
                      </div>
                    </>
                  );
                  break;
                case "MISSED":
                  content = (
                    <>
                      <div className="sn-call-type-newer-call">
                        <i className="mdi mdi-phone-missed sn-out-missed-text sn-never-attended-icon-mm" />
                        <span className="gap-2 sn-out-missed-call">
                          {callType.type}
                        </span>
                      </div>
                    </>
                  );
                  break;
                case "REJECTED":
                  content = (
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: "medium",
                        fontWeight: "bold",
                        color: "#e97dfb",
                      }}
                    >
                      <div className="sn-call-type-newer-call">
                        <i className="ri-indeterminate-circle-line rejected-icon-never" />
                        <span
                          className="gap-2 sn-out-missed-call"
                          style={{
                            color: "#e97dfb",
                            background: "rgb(233 125 251 / 10%)",
                          }}
                        >
                          {callType.type}
                        </span>
                      </div>
                    </div>
                  );
                  break;
                default:
                  content = null; // No content for other types
              }

              return (
                <React.Fragment key={index}>
                  {content}
                  {index !== row.type.length - 1 && <br />}
                </React.Fragment>
              );
            })
          )}
        </div>
      ),
    },

    {
      name: (
        <span
          className="font-weight-bold fs-13 text-center fs-2 fs-2"
          style={{ textTransform: "capitalize" }}
        >
          Attempt to Call
        </span>
      ),
      selector: (row) => {
        return (
          <>
            <h5
              className="font-weight-bold fs-13"
              style={{
                textTransform: "capitalize",
                color: "blue",
                fontWeight: "900",
                cursor: "pointer",
              }}
              onClick={() => {
                if (row.attempt > 0) {
                  showModal(row);
                }
              }}
            >
              <span
                style={{
                  color: row.attempt > 0 ? "inherit" : "red",
                  cursor: "inherit",
                }}
              >
                {row.attempt > 0 ? `${row.attempt} Times` : "Not Attempted"}
              </span>
            </h5>
          </>
        );
      },
      sortable: true,
    },
  ];

  const handleSearch = (e) => {
    setQuery(e.target.value);
  };

  useEffect(() => {
    if (teamIndu) {
      if (!isFirstEffectRun && selectedEmployeeOptions?.length > 0) {
        let updatedIds =  selectedEmployeeOptions?.map((option) => option?.id) || [];
        if (updatedIds.length > 0) {
          let dateObj = {
            startDate: formatDate(selectedFromDate),
            endDate: formatDate(selectedToDate)
          }
          neverAttendedData(currentPage, 10, "", updatedIds, dateObj);
        }
        setIsFirstEffectRun(true); // Mark as executed
        setPrevEmployeesIds_Test(updatedIds)
      }
    } else {
      let updatedIds =  selectedEmployeeOptions?.map((option) => option?.id) || [];
      if (updatedIds.length > 0) {
        let dateObj = {
          startDate: formatDate(selectedFromDate),
          endDate: formatDate(selectedToDate)
        }
        neverAttendedData(currentPage, 10, "", updatedIds, dateObj);
      }
      setIsFirstEffectRun(true); // Mark as executed
      setPrevEmployeesIds_Test(updatedIds)
    }
  }, [selectedEmployeeOptions,appliedFilters]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query);
      setCurrentPage(1)
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [query]);

  useEffect(() => {
    if (BooleanWithSingleEmployeeLogin) {
      loginEmplolye()
      return;
    } else {
      if (isFirstEffectRun === true) {
        let updatedIds =  selectedEmployeeOptions?.map((option) => option?.id) || [];
        const fetchData = async () => {
          if (debouncedQuery.length >= 3 || debouncedQuery.length === 0) {
            let dateObj = {
              startDate: formatDate(selectedFromDateTwo),
              endDate: formatDate(selectedToDateTwo)
            }
            await neverAttendedData(currentPage, perPage, debouncedQuery, updatedIds, dateObj);
          }
        };

        fetchData();
      }
    }

    async function loginEmplolye() {
      let dateObj = {
        startDate: formatDate(selectedFromDate),
        endDate: formatDate(selectedToDate)
      }
      await neverAttendedData(currentPage, perPage, debouncedQuery, profileData._id, dateObj);
    }
  }, [debouncedQuery, currentPage, perPage,appliedFilters]);

  const showModal = async (row) => {
    setOutgoingCall(row);
    setmodal_animationFlip(true);
  };

  // Pagination handler
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      if (query.length >= 3) {
        setDebouncedSearchText(query);
      } else {
        setDebouncedSearchText(''); 
      }
    }, 300); 

    return () => {
      clearTimeout(handler); 
    };
  }, [query]);

 
  useEffect(() => {
    const filtered = (neverAttendData || []).filter((item) =>
      Object.values(item).some((value) =>
        value?.toString()?.toLowerCase()?.includes(debouncedSearchText.toLowerCase())
      )
    );
    setFilteredData(filtered);
    if (debouncedSearchText) setCurrentPage(1);
  }, [neverAttendData, debouncedSearchText]);

  const neverAttendedData = async (page, size = perPage, searchTerm = '', updatedIds, dateObj) => {
    setIsLoading(true);
    try {
      if (!updatedIds) {
        updatedIds = selectedEmployeeOptions2.map((userid) => userid?.id);
      }
      const id = appliedFilters?.employees.map((userid) => userid?.id);

      let data = {
         startDate: appliedFilters? formatDate (appliedFilters.fromDate): formatDate(selectedFromDate),
         endDate:  appliedFilters? formatDate (appliedFilters.toDate) :formatDate(selectedToDate),
        employeeIds: id? id : updatedIds,
      };
      const response = await api.create(`${NEVER_ATTENDED_REPORT}?pg=${page}&lm=${size}&query=${searchTerm}`, data);
      if (response && response?.success === true) {
        setIsLoading(false);
        const apiResponse = response?.data[0];
        const tableData = (apiResponse?.paginatedResults || [])?.map(
          (data, index) => ({
            name: data.name || "unknown",
            mobileNumber: data.empDescription[0]?.mobileNumber || "-",
            phoneNumber: data._id.phoneNumber || "-",
            fullName: `${data.empDescription[0]?.fullName || "unknown"}`,
            attempt: data.attempt || '-',
            date: data?.dataAndType || "-",
            time: data.dataAndType || "-",
            type: data.dataAndType || "-",
            countryCode: data?.empDescription[0]?.countryCode,
            team:data?.empDescription[0]?.team[0] || 'No Team' 
          })
        );
        setNeverAttendData(tableData);
        setTotalRows(apiResponse?.totalCount);
      }
    } catch (error) {
      if (!remainingDays === 0) {
        HandleErrorMessage(error);
      }
    } finally {
      setIsLoading(false);
    }
  };
  // expire plan  function
  const handleClose = () => {
    setIsExpiredModalOpen(false);
    navigate("/planPackage");
  };

  return (
    <React.Fragment>
      <div >
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card className="h-100">
                <CardBody>
                  <Row className=" sn-user-tble-manin-manage">
                    <Col lg={12}>
                    <div className="search-datatable-wrapper">
                      <CommanDataTables
                        paginationFlag={false}
                        setCurrentPage={setCurrentPage}
                        perPage={perPage}
                        handleSearch={handleSearch}
                        column={column}
                        searchText={query}
                        tableData={filterData}
                        handlePerRowsChange={handlePerRowsChange}
                        totalRows={totalRows}
                        currentPage={currentPage}
                        isLoading={isLoading}
                        handlePageChange={handlePageChange}
                        inputClass={
                          (neverAttendData && neverAttendData.length > 0) ||
                            query
                            ? "d-block mb-4"
                            : "d-none"
                        }
                      />
                      </div>
                    </Col> 
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ModalNeverAttended
            outgoingCall={outgoingCall}
            modal_animationFlip={modal_animationFlip}
            setmodal_animationFlip={setmodal_animationFlip}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ConsolidateNeverAttended;